import {
  withTranslation,
} from 'react-i18next';

import RegattaRequirementsSectionView from './RegattaRequirementsSectionView';

const TranslatedComponent = withTranslation()(RegattaRequirementsSectionView);

const Component = TranslatedComponent;

export default Component;
